import { Link } from "react-router-dom";
import { FiBookOpen, FiGift, FiSliders, FiSmartphone } from "react-icons/fi";
import HorizontalBookFilter from "./HorizontalBookFilter";

export default function CatalogueFilters({ filters, categories, publishers, filtersPath, prefetch, filterCount }) {
	const quickPicks = [
		{ label: "Free books", icon: FiGift, active: filters.pricingModelIs === "free", toggle: () => filters.changePricingModelIs(filters.pricingModelIs === "free" ? "" : "free") },
		{ label: "Digital", icon: FiSmartphone, active: filters.format === "digital", toggle: () => filters.changeFormat(filters.format === "digital" ? "" : "digital") },
		{ label: "Print editions", icon: FiBookOpen, active: filters.format === "physical", toggle: () => filters.changeFormat(filters.format === "physical" ? "" : "physical") },
	];
	return (
		<div className="catalogue-filter-bar">
			<div className="catalogue-quick-picks" role="group" aria-label="Quick filters">
				{quickPicks.map(({ label, icon: Icon, active, toggle }) => <button type="button" key={label} aria-pressed={active} onClick={toggle}><Icon aria-hidden="true" />{label}</button>)}
			</div>
			<div className="catalogue-facets">
				<HorizontalBookFilter filters={filters} categories={categories} publishers={publishers} />
				<Link className="catalogue-all-filters" to={filtersPath} onMouseEnter={prefetch} onFocus={prefetch}><FiSliders aria-hidden="true" />All filters{filterCount > 0 && <span>{filterCount}</span>}</Link>
			</div>
		</div>
	);
}
